var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridMap',_vm._b({ref:"mapRef",staticClass:"no-pointer-events"},'GridMap',_vm.composedProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }